import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Globe, RefreshCw, Search, Palette } from 'lucide-react';

const icons = [Globe, RefreshCw, Search, Palette];
const keys = ['s1', 's2', 's3', 's4'];

const ServicesPreview = () => {
  const { t } = useTranslation();
  return (
    <section id="services" data-testid="services-section" className="py-14 lg:py-20 bg-[#FAF8F5] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <motion.div className="absolute whitespace-nowrap" style={{ top: '5%' }}
          animate={{ x: ['0%', '-30%'] }} transition={{ duration: 35, repeat: Infinity, ease: 'linear' }}>
          <span className="text-[14vw] font-bold text-[#1A1816]/[0.025] tracking-[-0.05em] font-sans leading-none">
            SERVICES&nbsp;&nbsp;&nbsp;GROWTH&nbsp;&nbsp;&nbsp;SERVICES&nbsp;&nbsp;&nbsp;GROWTH
          </span>
        </motion.div>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <motion.div className="mb-16" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-[1px] bg-[#C9A96E]" />
            <span className="text-[9px] font-semibold tracking-[0.3em] uppercase text-[#8A857D]">{t('services.label')}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-sans font-bold text-[#1A1816] leading-tight">
            {t('services.title1')}<br /><span className="font-serif italic text-[#C9A96E]">{t('services.title2')}</span>
          </h2>
        </motion.div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {keys.map((k, i) => {
            const Icon = icons[i];
            return (
              <motion.div key={k} data-testid={`service-card-${i}`}
                className="group p-6 lg:p-8 border border-[#1A1816]/5 hover:border-[#C9A96E]/30 transition-all duration-500 bg-[#FAF8F5]"
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
                <Icon className="w-6 h-6 text-[#C9A96E] mb-5" strokeWidth={1.5} />
                <h3 className="text-base font-semibold text-[#1A1816] mb-3 leading-snug">{t(`services.${k}`)}</h3>
                <p className="text-sm text-[#8A857D] leading-relaxed">{t(`services.d${i + 1}`)}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;
